$(function () {
    const references = $('.page-post .container-references');

    $('.page-post .btn-expand-references').on('click', function () {
        references.toggleClass('is-open');
    });
});

$(function () {
    $('.page-post .btn-see-more button').on('click', function (evt) {
        $(this).parent().parent().addClass('is-open');
    });

    $('.page-post .container-see-more').each(function () {
        const container = $(this)[0].getBoundingClientRect();
        const texts = $(this).find('.see-more-text')[0].getBoundingClientRect();

        if (texts.height < container.height) {
            $(this).addClass('is-open');
        }
    });

    $('.page-post .container-see-more-press').each(function () {
        const container = $(this)[0].getBoundingClientRect();
        const texts = $(this).find('.see-more-text')[0].getBoundingClientRect();

        if (texts.height < container.height) {
            $(this).addClass('is-open');
        }
    });
});
